import { useState, useCallback } from 'react';
export function useCursorPagination() {
  const [currentOffset, setCurrentOffset] = useState(undefined);
  const [offsetHistory, setOffsetHistory] = useState([]);
  const handleNextPage = useCallback(nextOffset => {
    setCurrentOffset(prev => {
      setOffsetHistory(history => [...history, prev !== null && prev !== void 0 ? prev : '']);
      return nextOffset;
    });
  }, []);
  const handlePrevPage = useCallback(() => {
    setOffsetHistory(prev => {
      const previousOffset = prev.at(-1);
      setCurrentOffset(previousOffset);
      return prev.slice(0, -1);
    });
  }, []);
  const resetPagination = useCallback(() => {
    setCurrentOffset(undefined);
    setOffsetHistory([]);
  }, []);
  return {
    currentOffset,
    currentPage: offsetHistory.length + 1,
    hasPrev: offsetHistory.length > 0,
    handleNextPage,
    handlePrevPage,
    resetPagination
  };
}